export const CategoryGroupQueryKeys = {
  all: () => ["categoryGroups"],
  single: (categoryGroupId: string | undefined) => [...CategoryGroupQueryKeys.all(), categoryGroupId],
};
